import { render, staticRenderFns } from "./AffilaiteSettingsForm.vue?vue&type=template&id=8d082636&"
import script from "./AffilaiteSettingsForm.vue?vue&type=script&lang=js&"
export * from "./AffilaiteSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports